import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAcademicYears } from "../hooks/useAcademicYears";
import Loader from "components/Common/loader";
import { AcademicYear } from '../../../../types/AcademicYearTypes';
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

const AcademicYearDropdown = () => {
  const { t } = useTranslation();

  const { academicYears, fetchAcademicYears, updateUserAcademicYear } = useAcademicYears();
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState<AcademicYear | null | undefined>(academicYears[0]);
  const user = useSelector((state: RootState) => state.authSlice.user);
  useEffect(() => {
    setLoading(true);
    fetchAcademicYears();
    setSelectedYear(user?.academicYear);
    setLoading(false);
  }, []);


  const handleSelect = (year: AcademicYear) => {
    console.log(year);
    setSelectedYear(year);
    updateUserAcademicYear(year.id);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="dropdown me-2">
      <div className="pe-1 ms-1">
        <Link
          to="#"
          className="btn btn-outline-light fw-normal bg-white d-flex align-items-center p-2"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="ti ti-calendar-due me-1" />
          {t("academicYear")}: {selectedYear?.name}
        </Link>
        <div className="dropdown-menu dropdown-menu-right">
          {academicYears.map((year) => (
            <Link
              key={year.id}
              to="#"
              className={`dropdown-item d-flex align-items-center ${year.id === selectedYear?.id ? "active" : ""
                }`}
              onClick={() => handleSelect(year)}
            >
              {t("academicYear")}: {year.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AcademicYearDropdown;
